module.exports = __webpack_public_path__ + "static/media/Portfolio.83e00ec0.svg";